import { render, staticRenderFns } from "./PaginationComponent.vue?vue&type=template&id=588ad9ad&scoped=true&"
import script from "./PaginationComponent.vue?vue&type=script&lang=js&"
export * from "./PaginationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588ad9ad",
  null
  
)

export default component.exports